

export class VehicleDetailsAlertOutput implements IVehicleDetailsAlertOutput {
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id!: number;

    constructor(data?: IVehicleDetailsAlertOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_details_id = _data["vehicle_details_id"];
        }
    }

    static fromJS(data: any): VehicleDetailsAlertOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDetailsAlertOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_details_id"] = this.vehicle_details_id;
        return data; 
    }
}

export interface IVehicleDetailsAlertOutput {
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id: number;
}

